import DropHint from './base';
import { clamp } from "lodash-es";
const WIDTH = 60;
const HEIGHT = 20;
export default class AbsoluteSlotDropHint extends DropHint {
  constructor() {
    super(...arguments);
    this.hintClassName = '';
  }
  getRect(args) {
    // debugger;
    const rect = this.ownerSlot.slotContainerElement.getBoundingClientRect();
    return {
      x: clamp(args.clientX - rect.x, 0, rect.width - WIDTH),
      y: clamp(args.clientY - rect.y, 0, rect.height - HEIGHT),
      width: WIDTH,
      height: HEIGHT
    };
  }
  getAreaSize() {
    return WIDTH * HEIGHT;
  }
  getDescription() {
    return '放到此处(绝对定位)';
  }
  getRelatedCompPath() {
    return this.config.compPath;
  }
  async execute(executeArgs) {
    const {
      designer
    } = this;
    const toRemoveCompPath = this.editZoneState.currentDraggingCompPath;
    // 放到插槽的最末尾
    const insertPoint = `${this.ownerSlot.compPath}/${this.ownerSlot.slotId}/${this.config.insertIndex}`;
    // 为了避免 immutable 的奇怪事情，如果是 move 的话，需要使用原来 immutable 的那个 Layout 引用
    const layout = toRemoveCompPath ? designer.getCompAtPath(toRemoveCompPath) : designer.dragSource.layout;
    const newCompPath = await designer.spliceComp(toRemoveCompPath, insertPoint, layout);
    // 鼠标落点的相对坐标
    const {
      offsetX,
      offsetY
    } = executeArgs;
    // 编辑器缩放时鼠标的位置要算上缩放修正
    const zoomPercentage = this.designer.getZoomPercentage();
    // 把位置信息patch进style
    await designer.modifyComp(newCompPath, comp => {
      const style = {
        left: `${Math.round(offsetX / zoomPercentage)}px`,
        top: `${Math.round(offsetY / zoomPercentage)}px`
      };
      comp.style = {
        ...comp.style,
        ...style
      };
    });
    designer.compPath = newCompPath || '';
  }
}
//# sourceMappingURL=AbsoluteSlotDropHint.js.map
